import React, { useCallback } from 'react';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from 'react-hook-form';
import { contactUs } from '../../api/apiHandler';
import { showPromiseNotification } from '../../common/notification';
import { validateNoStartOrEndSpace } from '../../cutomValidationField';
import { useTranslation } from 'react-i18next';
import '../../i18';

const ContactUs = () => {
    const { t } = useTranslation();

    const contactUsSchema = Yup.object().shape({
        first_name: Yup.string()
            .required(t('required', { field: t("first_name") }))
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("First_Name") }), validateNoStartOrEndSpace)
            .min(2, t('min', { field: t("First_Name"), value: 2 }))
            .max(50, t('max', { field: t("First_Name"), value: 50 }))
            .matches(
                /^[a-zA-Z\s'-]*$/,
                t("fullNameValidation", { field: t("First_Name") })
            ),

        last_name: Yup.string()
            .required(t('required', { field: t("last_name") }))
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("Last_Name") }), validateNoStartOrEndSpace)
            .min(2, t('min', { field: t("Last_Name"), value: 2 }))
            .max(50, t('max', { field: t("Last_Name"), value: 50 }))
            .matches(
                /^[a-zA-Z\s'-]*$/,
                t("fullNameValidation", { field: t("Last_Name") })
            ),

        email: Yup.string()
            .email(t('valid', { field: t("email") }))
            .required(t('required', { field: t("email") })),

        subject: Yup.string()
            .required(t('required', { field: t("subject") }))
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("Subject") }), validateNoStartOrEndSpace)
            .min(3, t('min', { field: t("Subject"), value: 3 }))
            .max(100, t('max', { field: t("Subject"), value: 100 }))
            .matches(
                /^[a-zA-Z\s'-]*$/,
                t("fullNameValidation", { field: t("Subject") })
            ),

        description: Yup.string()
            .required(t('required', { field: t("description") }))
            .test('no-start-or-end-space', t('noStartEndSpace', { field: t("Description") }), validateNoStartOrEndSpace)
            .min(10, t('min', { field: t("Description"), value: 10 }))
            .max(1000, t('max', { field: t("Description"), value: 1000 })),
    });

    const formOptions = { resolver: yupResolver(contactUsSchema) };
    const { register, handleSubmit, formState, reset } = useForm(formOptions);
    const { errors } = formState;

    const onSubmit = useCallback(
        async (values) => {
            const myPromise = new Promise(async (resolve, reject) => {
                const response = await contactUs(values)
                if (response.code == 200) {
                    resolve(response);
                } else {
                    reject(response);
                }
                reset();
            });
            showPromiseNotification(myPromise);
        }
    )

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('contactUsHeading')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="counter-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-4 mt-3 mt-sm-0">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="contact-list-inner">
                                                <div className="media">
                                                    <div className="media-left">
                                                        <img src={process.env.PUBLIC_URL + "/assets/img/icon/17.png"} alt="img" />
                                                    </div>
                                                    <div className="media-body align-self-center">
                                                        <h5>{t('ourPhone')}</h5>
                                                        <p>{t('contactNo')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="contact-list-inner">
                                                <div className="media">
                                                    <div className="media-left">
                                                        <img src={process.env.PUBLIC_URL + "/assets/img/icon/18.png"} alt="img" />
                                                    </div>
                                                    <div className="media-body align-self-center">
                                                        <h5>{t('ourEmail')}</h5>
                                                        <p>{t('contactEmail')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="contact-list-inner ">
                                                <div className="media">
                                                    <div className="media-left">
                                                        <img src={process.env.PUBLIC_URL + "/assets/img/icon/16.png"} alt="img" />
                                                    </div>
                                                    <div className="media-body align-self-center">
                                                        <h5>{t('ourAddress')}</h5>
                                                        <p>{t('address')}</p>
                                                        <p>{t('address1')}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 mt-2 mt-sm-2 mt-lg-0">
                                    <form className="contact-form-inner" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="single-input-inner style-bg-border">
                                                    <input type="text" placeholder={t("enterFieldName", { field: t("First_Name") })} name='first_name'
                                                        {...register('first_name')}
                                                    />
                                                    <p className="text-danger mt-1">
                                                        {errors.first_name?.message}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="single-input-inner style-bg-border">
                                                    <input type="text" placeholder={t("enterFieldName", { field: t("Last_Name") })} name='last_name'
                                                        {...register('last_name')}
                                                    />
                                                    <p className="text-danger mt-1">
                                                        {errors.last_name?.message}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="single-input-inner style-bg-border">
                                                    <input type="text" placeholder={t("enterFieldName", { field: t("Email") })} name='email'
                                                        {...register('email')}
                                                    />
                                                    <p className="text-danger mt-1">
                                                        {errors.email?.message}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="single-input-inner style-bg-border">
                                                    <input type="text" placeholder={t("enterFieldName", { field: t("Subject") })} name='subject'
                                                        {...register('subject')}
                                                    />
                                                    <p className="text-danger mt-1">
                                                        {errors.subject?.message}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="single-input-inner style-bg-border">
                                                    <textarea placeholder={t("enterFieldName", { field: t("Description") })} defaultValue={""} name='description'
                                                        {...register('description')}
                                                    />
                                                    <p className="text-danger mt-1">
                                                        {errors.description?.message}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <button className="btn btn-base">{t('sendMessage')}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUs;